import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "product-gallery-form",
  templateUrl: "./product-gallery-form.component.html",
  styleUrls: ["./product-gallery-form.component.scss"],
})
export class ProductGalleryFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-gallery-form/product-gallery-form.component.ts